/* Animated number counters.
 *
 * Usage: <dt data-count-to="300" data-count-suffix="+">0</dt>
 *
 * Runs once per element when it scrolls into view. Honors prefers-reduced-motion
 * (snaps straight to the final value). Uses a cubic ease-out for a natural
 * settle rather than a linear climb.
 */

const EASE_OUT_CUBIC = (t) => 1 - Math.pow(1 - t, 3);

export function initCounters() {
  const targets = document.querySelectorAll('[data-count-to]');
  if (!targets.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const paint = (el) => {
    const to     = parseFloat(el.dataset.countTo);
    const prefix = el.dataset.countPrefix || '';
    const suffix = el.dataset.countSuffix || '';
    const duration = 1400;

    if (reduced) {
      el.textContent = prefix + formatInt(to) + suffix;
      return;
    }

    const start = performance.now();
    const step  = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const v = Math.round(to * EASE_OUT_CUBIC(p));
      el.textContent = prefix + formatInt(v) + suffix;
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  if (!('IntersectionObserver' in window)) {
    targets.forEach(paint);
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        paint(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });

  targets.forEach((el) => io.observe(el));
}

function formatInt(n) {
  return Number(n).toLocaleString('en-US');
}
